<template>
  <div :class="`form-group row form-group-border-bottom align-items-center ${forceWhite}`" :style="field.in_popup ? 'margin-right: 0px; margin-left:0px;' : ''">
    <label 
      v-if="label" 
      :for="name" 
      :class="[labelSize, labelClasses]" 
      class="col-form-label" 
      :style="labelStyle"
    >
      <span v-if="field.required" class="required">*</span>
      <span v-html="label"></span>
    </label>
    <div class="align-items-center" :class="colSize">
      <div class="password-field-wrapper" :class="{ 'has-password-toggle': isPassword }">
        <input
          autocomplete="off"
          :type="inputType"
          class="form-control-plaintext additionalclass"
          :class="{ 'israeli-id-input': isIsraeliId }"
          :id="name"
          :aria-describedby="describedBy"
          :aria-invalid="hasError ? 'true' : undefined"
          :aria-required="field.required ? 'true' : undefined"
          :name="name"
          :value.attr="valueParsed"
          :dir="dir"
          :placeholder="placeholder"
          :required="field.required"
          :inputmode="isIsraeliId ? 'numeric' : undefined"
          :data-validate="isIsraeliId ? 'israeli_id' : undefined"
          :data-allow-test="isIsraeliId ? String(Boolean(field.allow_test)) : undefined"
          :data-validate-on-submit="isClientValidatedField ? 'true' : undefined"
          @input="onInput"
        >
        <button
          v-if="isPassword"
          type="button"
          class="password-toggle-btn"
          :aria-label="passwordToggleLabel"
          :aria-pressed="passwordVisible ? 'true' : 'false'"
          @click.prevent="togglePasswordVisibility"
        >
          <SvgImage :src="passwordToggleIcon" class="password-toggle-icon" aria-hidden="true" />
        </button>
      </div>
      <div
        class="invalid-feedback client-validate"
        :id="`${name}invalid`"
        :class="{ show: showFeedback }"
      >{{ feedbackText }}</div>
      <!-- <small :id="`fieldDescription_` + name" class="form-text text-muted">We'll never share your email with anyone else.</small> -->
    </div>
  </div>
</template>
<script>
import SvgImage from "@/components/generic/SvgImage";
import { clientFieldValidationMessage } from "@/modules/israeliId.js";

export default {
  components: {
    SvgImage
  },
  props: {
    label: String,
    type: String,
    name: String,
    value: String,
    field: Object,
  },
  data() {
    return {
      passwordVisible: false,
      showError: false,
      shownError: "",
      ownerForm: null,
      boundFormValidate: null,
    }
  },
  computed: {
    isPassword() {
      return this.type == 'password';
    },
    inputType() {
      if (this.isPassword) return this.passwordVisible ? 'text' : 'password';
      return this.type;
    },
    passwordToggleIcon() {
      return this.passwordVisible
        ? require('@/assets/icons/eye-off.svg')
        : require('@/assets/icons/eye.svg');
    },
    passwordToggleLabel() {
      return this.passwordVisible ? 'הסתר סיסמה' : 'הצג סיסמה';
    },
    isIsraeliId() {
      return this.field?.validate === "israeli_id";
    },
    isClientValidatedField() {
      // JSON error_message / error_blank are templates, not an active error.
      // Show them only after validateForm / yummi-validate fails.
      return (
        this.isIsraeliId ||
        !!this.field?.validate_on_submit ||
        !!this.field?.required ||
        !!this.field?.error_message ||
        !!this.field?.error_blank
      );
    },
    dir() {
      if (this.isIsraeliId) return "ltr";
      if (this.type == 'email') return "ltr";
      if (this.type == 'password') return "ltr";
      if (this.field?.dir == 'ltr') return this.field?.dir;
      return "rtl";
    },
    valueParsed() {
      // if (!this.value) return this.value;
      if (this.type == 'date') {
        return this.field.value;
      }
      return this.value;
    },
    placeholder() {
      if (!this.field) return "";
      if (this.field?.default_text) return this.field?.default_text;
      return "";
    },
    colSize() {
      if (!this.label) return 'col-12';
      return this.field.inputContainerClass || 'col-6 col-xl-8';
    },
    labelSize() {
      return this.field.labelClass || 'col-auto col-xl-auto';
    },
    labelStyle() {
      if (this.field?.dir == 'ltr') return "padding-left: 12px;";
      return ""; 
    },
    forceWhite() {
      if (this.field.white) return "forceWhite";
      return "";
    },
    labelClasses() {
      const classes = [];
      
      // Add bold class if field.bold_label is true
      if (this.field?.bold_label) {
        classes.push('bold');
      }
      
      // Future: Add more conditional classes here
      // if (this.field?.some_other_style) {
      //   classes.push('some-other-class');
      // }
      
      return classes;
    },
    hasError() {
      return this.showError;
    },
    showFeedback() {
      return this.showError;
    },
    feedbackText() {
      if (this.showError) {
        return this.shownError || this.field?.error_message || "";
      }
      return this.field?.error_message || "";
    },
    describedBy() {
      if (this.hasError) {
        return `${this.name}invalid`;
      }
      return undefined;
    }
  },
  mounted() {
    this.boundFormValidate = (event) => this.onFormValidate(event);
    this.ownerForm = this.$el?.closest?.("form") || null;
    this.ownerForm?.addEventListener("yummi-validate", this.boundFormValidate);
  },
  beforeUnmount() {
    this.ownerForm?.removeEventListener("yummi-validate", this.boundFormValidate);
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
    onInput() {
      if (this.showError) {
        this.showError = false;
        this.shownError = "";
      }
    },
    onFormValidate(event) {
      if (!this.isClientValidatedField) {
        return;
      }
      if (!this.validateNow()) {
        event?.detail?.markInvalid?.();
        if (event?.detail && !event.detail.focusTarget) {
          event.detail.focusTarget = this.$el?.querySelector?.("input") || null;
        }
      }
    },
    validateNow() {
      const input = this.$el?.querySelector?.("input");
      const message = clientFieldValidationMessage(input?.value, this.field);
      if (message) {
        this.shownError = message;
        this.showError = true;
        return false;
      }
      this.shownError = "";
      this.showError = false;
      return true;
    }
  }
}
</script>
<style scoped>
.additionalclass {
  position: relative;
  top: 2px;
}
.required {
  color: red;
  margin-left: 5px;
}
.forceWhite {
  background-color: white;
}
.password-field-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}
.password-field-wrapper.has-password-toggle input {
  padding-left: 28px;
}
.password-toggle-btn {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 4px;
  margin: 0;
  cursor: pointer;
  line-height: 0;
}
.password-toggle-icon {
  width: 18px;
  height: 18px;
  display: block;
}
.invalid-feedback.client-validate {
  display: none !important;
}
.invalid-feedback.client-validate.show {
  display: block !important;
}
.israeli-id-input:focus,
.israeli-id-input:focus-visible {
  outline: none !important;
  outline-offset: 0 !important;
  box-shadow: none !important;
}
</style>